import { useMemo } from "react";
import { UserAPI } from "@ai360/core";
import { useAppSelector } from "~/store/hooks";
import { getLoginGuid } from "~/login/selectors";

const convertBoolean = (value) => {
    if (value === "True") return true;
    if (value === "False") return false;
    return value;
};

const useReportPreferences = (reportName, preferences) => {
    const loginGuid = useAppSelector(getLoginGuid);

    const preferenceNames = useMemo(
        () => preferences.map((pref) => `${reportName}_${pref}`),
        [preferences, reportName]
    );

    const { data, error, isLoading } = UserAPI.useGetReportPreferencesQuery(loginGuid, {
        skip: !loginGuid,
    });

    const reportPreferences = useMemo(() => {
        if (!data) return undefined;
        return data
            .filter((p) => preferenceNames.length === 0 || preferenceNames.includes(p.id.name))
            .reduce((acc, p) => {
                const key = p.id.name.replace(`${reportName}_`, "");
                acc[key] = convertBoolean(p.value);
                return acc;
            }, {});
    }, [data, reportName, preferenceNames]);

    return { reportPreferences, error, isLoading };
};

export default useReportPreferences;
